/**
 * Colored CLI output helpers — wraps chalk for consistent styling.
 *
 * Success = green, errors = red, warnings = yellow,
 * labels = bold, tips = dim.
 */

import chalk from 'chalk'

/** Green success message. */
export function success(msg: string): void {
  console.log(chalk.green(msg))
}

/** Red error message to stderr. */
export function error(msg: string): void {
  console.error(chalk.red(msg))
}

/** Yellow warning to stderr. */
export function warn(msg: string): void {
  console.error(chalk.yellow(msg))
}

/** Bold key + normal value on one line. */
export function label(key: string, value: string): void {
  console.log(`${chalk.bold(key)} ${value}`)
}

/** Dim secondary text (tips, hints). */
export function dim(msg: string): void {
  console.log(chalk.dim(msg))
}

/** Bold text. */
export function bold(msg: string): void {
  console.log(chalk.bold(msg))
}

/** Colorize a status word inline: green=healthy/completed/online, red=failed/error, yellow=processing. */
export function status(s: string): string {
  const lower = s.toLowerCase()
  if (['healthy', 'completed', 'available', 'online', 'on'].includes(lower)) return chalk.green(s)
  if (['failed', 'error', 'unavailable', 'offline'].includes(lower)) return chalk.red(s)
  if (['processing', 'pending', 'degraded', 'warning'].includes(lower)) return chalk.yellow(s)
  return s
}

/** Cyan for IDs, URLs, and other reference values. */
export function ref(s: string): string {
  return chalk.cyan(s)
}

export { chalk }
